<template>
  <div>
    <v-card color="grey lighten-4" flat tile> </v-card>
    <v-main>
      <slot class="default" name="default"></slot>
    </v-main>
  </div>
</template>

<script>
export default {
  name: "blank-layout",
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped></style>
